<template>
  <p-container class="dashboard">
    <p-row>
      <p-col justify-center md-12>
        <h1>Elysator.IL</h1>
      </p-col>
    </p-row>
    <p-row>
      <p-col sm12 md6>
        <p-card class="app">
          <h2>H<sub>2</sub>O GUARD hub</h2>
          <p class="message">
            {{ $t('page.dashboard.app.guard.hub.description') }}
          </p>
          <p-button @click="gotoHub()">
            {{ $t('page.dashboard.button.openLink') }}
          </p-button>
        </p-card>
      </p-col>
      <p-col sm12 md6>
        <p-card class="app">
          <h2>H<sub>2</sub>O GUARD dTrace</h2>
          <p class="message">
            {{ $t('page.dashboard.app.guard.dTrace.description') }}
          </p>
          <p-button @click="gotoDTrace()">
            {{ $t('page.dashboard.button.openLink') }}
          </p-button>
        </p-card>
      </p-col>
    </p-row>
  </p-container>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    auth: true,

    methods: {
      gotoHub() {
        window.open('https://my.elysator.com/hub');
      },
      gotoDTrace() {
        window.open('https://my.elysator.com/dTrace');
      },
    },
  });
</script>
